
import React from 'react'
import FileUpload from '../../../../../../components/stateful/fileUpload/FileUpload'
import { Filing } from '../../../../../../utilities/interfaces/Filing';
import ExpansionPanel from '../../../../../../components/stateless/expansionPanel/ExpansionPanel';
import { useFilingUploadController } from './FilingUploadController';
import { DocumentType } from '../../../../../../utilities/enums/DocumentType';

interface IFilingUploads {
  filing: Filing;
  readOnly: boolean;
}

const FilingUploads = (props: IFilingUploads) => {
  const { filing, readOnly } = props;

  const {
    // variables
    filingSummaryDocs,
    filingSupportingDocs,
    filingHearingDocs,
    filingAffidavitDocs,
    filingFiscalDocs,
    filingExplanatoryDocs,
    filingGPRODocs,
    filingCoverLetterDocs,
    filingCertificateOfAdoptionDocs,
    // functions
    handleFileUploadResponseMessage,
    saveAdditionalDoc,
    deleteAdditionalDoc,
  } = useFilingUploadController(filing);

  return (
    <>
      <ExpansionPanel fullwidth title="Affidavit of Publication" item={{ id: 'affidavitOfPublication' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingAffidavitDocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType['Affidavit of Publication']) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
      <ExpansionPanel fullwidth title="Certificate of Adoption" item={{ id: 'certificateOfAdoption' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingCertificateOfAdoptionDocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType['Certificate of Adoption']) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
      <ExpansionPanel fullwidth title="Cover Letters and Statements" item={{ id: 'coverLettersAndStatements' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingCoverLetterDocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType['Cover Letters and Statements']) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
      <ExpansionPanel fullwidth title="Explanatory Statement" item={{ id: 'explanatoryStatement' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingExplanatoryDocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType['Explanatory Statement']) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
      <ExpansionPanel fullwidth title="Fiscal Impact Statement" item={{ id: 'fiscalImpactStatement' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingFiscalDocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType['Fiscal Impact Statement']) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
      <ExpansionPanel fullwidth title="Gov Checklist" item={{ id: 'gproChecklist' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingGPRODocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType['Gov Checklist']) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
      <ExpansionPanel fullwidth title="Hearing Notice" item={{ id: 'hearingNotice' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingHearingDocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType['Hearing Notice']) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
      <ExpansionPanel fullwidth title="Hearing Summary" item={{ id: 'hearingSummary' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingSummaryDocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType['Hearing Summary']) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
      <ExpansionPanel fullwidth title="Additional Files" item={{ id: 'additionalFiles' }}>
        <FileUpload
          containerName={"filing-documents"}
          existingFiles={filingSupportingDocs}
          type="file"
          disabled={readOnly}
          required={false}
          notification={handleFileUploadResponseMessage}
          saveFile={(file: any) => { saveAdditionalDoc(file, DocumentType.Misc) }}
          deleteFile={deleteAdditionalDoc}
          allowedTypes={'whitelist'}
        />
      </ExpansionPanel>
    </>
  )
}

export default FilingUploads